import type { RequestOptions } from '@@/plugin-request/request';
import { BizAppConfig } from 'config/application.manifest';

type ScopedRequestOptions = RequestOptions;

export function createRequest(baseURL?: string) {
  const scopedBaseURL = baseURL ?? BizAppConfig.appApiUrl ?? '';
  return <T = unknown>(url: string, options?: ScopedRequestOptions) => {
    // Lazy-load @umijs/max so Jest/app bootstrap cannot circularly
    // initialize this module before BizAppConfig is ready.
    const { request: umiRequest } = require('@umijs/max') as {
      request: <R = unknown>(
        requestUrl: string,
        requestOptions?: ScopedRequestOptions,
      ) => Promise<R>;
    };

    return umiRequest<T>(url, {
      baseURL: scopedBaseURL,
      ...(options || {}),
    });
  };
}

export function createAppRequest() {
  return createRequest(BizAppConfig.appApiUrl);
}

export function createTenantManagementRequest() {
  return createRequest(BizAppConfig.appTenantManagementUrl);
}
